import request from '@/utils/request'

export const productsList = (page,pageSize,is_active) => {
  return request.get('/goods/projectList', {
    params: {
      page: page ,// 动态传递页码
      pageSize:pageSize, //每页数量
      is_active:is_active
    }
  })
}

// 获取商品详情
export const productDetail = (id) => {
  return request.get('/goods/detail', {
    params: { id: id } // 使用 params 传递 id
  })
}



// api/search.js
export const advancedSearch = (filters) => {
  return request.post('/goods/advanced-search', { filters }, { // 包装为 { filters: { ... } }
    headers: {
      'Content-Type': 'application/json',  // 指定请求头为 JSON 格式
    },
  });
};



// 获取系统设置首页banner图片
export const getSettings = () => {
  return request.get('/get-settings');
}

export const getProjectImages = (projectId) => {
  return request.get('/goodsimages', {
    params: { id: projectId } // 通过 query 传递 id
  });
};